<template>
  <div>
    <hero-global title="Cómo asociarse" subtitle="Cómo asociarse al CERMI" breadcrumb="Cómo asociarse al CERMI"
      img="/img/how-to-join-cermi/how-to-join-cermi.svg" first-width="70" last-width="30" />
  </div>
  <section class="container p-x-3-rem container-asociarse-al-cermi-editor-js">
    <EditorJs v-if="entry" :object="entry.body" />
  </section>
  <div class="container p-x-3-rem">
    <section>
      <carrousel2 />
    </section>
    <other-links-interest class="links-interest-box container" />
    <br />
    <br />
  </div>
</template>

<script>
import HeroGlobal from "@/components/Global/HeroGlobal";
import Carrousel2 from "@/components/Global/Carrousel2";
import OtherLinksInterest from "@/components/Layout/OtherLinksInterest";
import { contentStore } from '@/stores/contents';
import EditorJs from "@/components/Global/editorJs.vue"
export default {
  name: "HowToJoinCermi",
  components: { OtherLinksInterest, Carrousel2, HeroGlobal, EditorJs },
  setup() {
    const store = contentStore();
    return {
      store
    }
  },
  mounted() {
    this.store.loadPageFixed({
      slug: this.$route.path.replace('/', '')
    });
  },
  computed: {
    entry() {
      return this.store.getPageFixed(this.$route.path.replace('/', ''))
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/colours";

figure {
  margin: 0;
}

img {
  max-width: 100%;
  height: auto;
}

article {
  max-width: 1440px;
  margin: auto;
  display: grid;
  grid-column: auto;
}

article>* {
  grid-column: main;
}

.floating figure {
  float: right;
  max-width: 50%;
  margin-right: 20px;
}

.floating p {
  margin-top: 0;
}


</style>
